/*
 * ===============================================================================================================
 *                                Copyright 2020-2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

export interface LuiTreeProps {
    data: MultiSelectItem[];
    keyAccessor: string;
    displayAccessor: string;
    onSelectItem: (selectedItem: NodeItem, tree: NodeItem[]) => void;
    selectedItems: string[];
    showSelection: boolean;
    width?: string | number;
    className?: string;
    handleItemClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>, selectedItem: NodeItem) => void;
    expandedItems: string[];
}

export interface MultiSelectItem {
    name: string;
    key: string;
    children?: Array<MultiSelectItem>;
    [key: string]: any;
}

export interface NodeItem extends MultiSelectItem {
    checkStatus: CheckStatus;
    selected: boolean;
    parent?: NodeItem;
    children?: NodeItem[];
    allowExpandItem?: boolean;
}

export enum CheckStatus {
    CHECKED = 1,
    UNCHECKED = 0,
    INDETERMINATE = 2,
}